export default __webpack_public_path__ + "static/media/book-and-magnifier.cf579bff.svg";